module.exports = __webpack_public_path__ + "img/bgMikeBreakout@2x.15e6152b.jpg";